import moment from 'moment'
import Application from './loopback_api.coffee'
import * as crashReporter from './crash_reporter.coffee'
import {retryAbortedRead} from './transition_recovery.coffee'
import {createShellRouter, startReact, renderReactError, parseUrl, normalizeRoute} from './shell.coffee'
import {routes, guards} from './routes.coffee'
import {mergeHostedRoutes} from './hosted/hosted_routes.coffee'
import {hostedScreen} from './hosted/hosted_screen.coffee'
import {isMobileDevice, classicChosen, setMobileView, applyClassicParam} from './hosted/mobile_device.coffee'
import {chooseMenu, accountKey, resolveMenu} from './menu_config.coffee'
import {storedScheme, setScheme} from './color_scheme_rules.coffee'
import {landingRoute} from './landing.coffee'
import {isDeadSession, servesBootRead, signOutToSignIn, hasBootIdentity, confirmSessionIdentity as confirmTokenIdentity} from './dead_session.coffee'
import {decodeRedirectParams, routeHash, linkReplacesSession} from './deep_link.coffee'
import {patchPlaybackResourceHandoff, patchWebAudioDecodeRejection} from './sound_playback_patch.coffee'
import { hide_agent_widget } from './common.coffee'
import ClientAPI from  "../../../../schema/framework/shared/client_api.coffee"
import {i18nCreateElement, initI18n, I18nRegistry, t} from '../../../../schema/framework/shared/i18n/index.coffee'
import {ENROLL_COMPLETE_PATH} from './StudentApplication/enrollRedirect.coffee'
import {isActiveSubscription, studentSessionSubscribed, subscribedWithoutStudents, scholarshipIsServed, SCHOLARSHIP_STATE, DELETE_ACCOUNT_STATE, selfDeletable, STUDENTS_SCREEN_HASH} from './subscriptionRouting.coffee'
import * as remoteLogging from './remote_logging.coffee'

# createjs 1.0.0 hands a freshly loaded buffer to the instances waiting for it
# with a method that release does not have, and throws instead (card
# 6aab65a36c29c3a6dc3bbbb7). Patched HERE, at module scope in the webpack entry,
# because AbstractPlugin.register captures the handler as the loader's complete
# listener — a sound registered before this call would keep the broken one.
patchPlaybackResourceHandoff()

# And createjs 1.0.0's WebAudioLoader drops the promise decodeAudioData returns,
# so a clip WebKit cannot decode is an unhandled EncodingError and the child's
# say() never finishes (card 6ab1f98bcb41c3b4ffd4bd76). Same reason for the same
# placement: the loader class is captured when a sound is registered.
patchWebAudioDecodeRejection()

params = parseUrl window.location.href
console.log "View Params:"
console.dir params

# WHOSE LINK WAS THIS — card 6aaf07728b7b7297d73a152b.
#
# A crash at boot is the one crash with nobody on it: no session, and on a
# device that has never signed in, no remembered identity either, so the
# CrashLog row says identitySource 'none' and support cannot tell which
# family's QR sheet is out of date. Five of the nine real rows in the first day
# of capture were exactly this.
#
# But the URL knew. /app?access_token=<unusable>&uid=<login id> names the
# principal it was minted for even when the token cannot authenticate — which
# is the whole of the stale-QR case (card 6aae789375583968aa813992). Hand it to
# the reporter HERE, before anything can throw: this runs at module scope,
# ahead of loadSchema, the Application constructor and crashReporter.install,
# so a crash anywhere in the boot still carries it.
#
# Recorded as identitySource 'attempted' and ranked below both real sources —
# it is what a link claimed, on a credential we may be about to reject, and it
# must never be mistaken for somebody who signed in.
crashReporter.noteAttemptedIdentityFromUrlParams params
clientAPI = new ClientAPI(window.config.basePath || '', "/clientapi", "$LoopBack$", {
  socketExcludePatterns: ['placement_report']
  blobOperations: ['Student.placement_report']
})
# Pre-set auth from URL params before loading schema.
# Without this, arriving with no cached token causes loadSchema() to run
# unauthenticated, returning a schema missing subscriber-only methods.
#
# A link for somebody OTHER than the session this browser holds installs the
# link's session — linkReplacesSession (deep_link.coffee), card
# 6ac449205e862d397de34685. Holding any session used to be enough to keep it.
if params.access_token? && !/#/.test(params.studentId)
  if linkReplacesSession(params, clientAPI)
    clientAPI.setUser(params.access_token, params.uid, undefined, params.studentId)
    clientAPI.resetAuthHeader()
    # AN OLD QR CODE IS NOT A SESSION — card 6aae789375583968aa813992.
    #
    # setUser answers by CLEARING the session when the token does not carry the
    # <Model>Auth_ framing (framework/shared/client_api.coffee), which is every
    # link minted before the v3 cutover. So isLoggedIn() false HERE means the
    # URL carried a token that can never authenticate. Remember that: the boot
    # branch below re-installs it, fails the same way, and would otherwise walk
    # into refresh() -> Account.getAccount on an anonymous manifest.
    #
    # sessionStorage directly, not Application.setStaleLinkFlag: window.app is
    # constructed after loadSchema() resolves and does not exist yet. The key
    # is the one loopback_api.coffee reads.
    sessionStorage?.setItem("StaleAccessTokenLink", "true") unless clientAPI.isLoggedIn()
# THE SCHEMA LOAD IS A BOOT READ TOO — card 6abc395ba68734bf39cc263d. It is the
# first request the page makes, before the crash reporter or window.app exist, and
# an aborted GET /clientapi on a LIVE page (axios 'Request aborted'; axios-retry does
# not retry ECONNABORTED) rejected with no .catch: the child sat on "Loading App..."
# for good and nothing was reported. Reproduced on the QA bundle by aborting
# /clientapi; 37 activities-run loads ended this way on 2026-09-29. Same retry,
# same judgment as the account read below.
retryAbortedRead((-> clientAPI.loadSchema()), (error) ->
  console.warn "Schema load was aborted (#{error?.message ? error}) — retrying"
).then () ->
  crashReporter.install('app')   # card 6aad7bb96e6a1e18a090353b: crashes report themselves
  window.app = new Application(clientAPI)

  # Remote Logging survives a reload on purpose (card 6aac4153fb9b132bb83a8911).
  # A customer arms it, then reproduces the problem — and reproducing almost
  # always involves navigating, so an arm that died at the first page load
  # would capture everything except the thing support asked for. Never allowed
  # to fail the boot: a diagnostic that takes the app down is worse than one
  # that does not start.
  try
    remoteLogging.restore()
  catch err
    console.warn "[remote logging] could not restore an armed session: #{err?.message or err}"

  # Make i18n functions globally available
  window.i18nCreateElement = i18nCreateElement
  window.t = t

  # TEMPORARY HACK: we have to load the css manually until the next version is
  #               : deployed to Android
  if window.app.isAndroid()
    console.warn "Android :: Checking for old *fake* CSS..."
    oldNode = document.querySelector('link[href="https://unpkg.com/react-md@1.2.3/dist/react-md.purple-deep_orange.min.css"]')
    if oldNode?
      console.warn "Android :: Updating old *fake* CSS..."
      oldNode.setAttribute('href', "#{window.config.s3_assets}css/react-md.min.css")

      console.warn "Android :: Adding new resets CSS..."
      resetsNode = document.createElement('link')
      resetsNode.setAttribute('rel', 'stylesheet')
      resetsNode.setAttribute('href', "#{window.config.s3_assets}css/resets.css")

      parentNode = oldNode.parentNode
      parentNode.insertBefore(resetsNode, oldNode)

  hide_agent_widget() if window.app.isApp()

  # The router, its hooks (transition recovery, the route-change upgrade, the
  # i18n context) and the React root are the three shells' shared code
  # (shell.coffee, card 6ac022cba664bc34d57be8c3). An unknown URL opens the
  # dashboard, whose guard sends a signed-out visitor to sign in.
  #
  # ON A MOBILE DEVICE the one App row the server names (window.hostedApps.mobile,
  # common/hostedApp.coffee) adds its screens to the same table — cards
  # 6ac022cba664bc34d57be8c5 and 6ac022cba664bc34d57be8c7. Anywhere else, and
  # with no row named, the table is exactly the built-in one.
  #
  # CLASSIC VIEW (hosted/mobile_device.coffee): a device that chose it gets the
  # built-in table, and the drawer offers the way back to the new view.
  shellRoutes = routes
  mobileManifest = window.hostedApps?.mobile?.manifest
  applyClassicParam window
  window.app.mobileViewAvailable = mobileManifest? and isMobileDevice(window.app, window)
  window.app.classicView = window.app.mobileViewAvailable and classicChosen(window)
  window.app.setMobileView = (view) -> setMobileView view, window
  # Appearance: Auto / Light / Dark per device (card 6ac15a50270c80c6c2166c91),
  # for the classic drawer and the hosted Mobile Shell row alike.
  window.app.colorScheme = -> storedScheme window
  window.app.setColorScheme = (choice) -> setScheme choice, window
  host = (table, which, opts = {}) ->
    merged = mergeHostedRoutes table, window.hostedApps[which].manifest, (entry) -> hostedScreen entry, opts
    for r in merged.refused
      message = "Hosted screen '#{r.name ? r.key}' from App #{window.hostedApps[which].appId} was refused: #{r.reason}"
      console.error message
      window.app.trackError? message
    merged
  if window.app.mobileViewAvailable and not window.app.classicView
    merged = host routes, 'mobile'
    shellRoutes = merged.routes
    window.app.hostedRoutes = merged.hosted
  # THE SCREENS APP (card 6ac022cba664bc34d57be8c9, owner 2026-10-03): the
  # screens the menus open (menu_config.coffee), hosted on every device and in
  # either view. After the mobile App, so a key both name stays the mobile one's
  # and the screens one is refused loudly. Never the landing screen.
  if window.hostedApps?.screens?.manifest?
    merged = host shellRoutes, 'screens', {titleBar: true}
    shellRoutes = merged.routes
    window.app.screenRoutes = merged.hosted
  # An address no route claims opens the landing screen (landing.coffee, card
  # 6ac022cba664bc34d57be8c7): the dashboard, or on a mobile device that hosts
  # the mobile App, its dashboard.
  # The route names a Menu document may open (menu_config.coffee).
  window.app.routeNames = {}
  for own key, r of shellRoutes
    window.app.routeNames[key] = true
    window.app.routeNames[r.name] = true if r?.name?
  # The mobile Shell row builds its menu with the same two calls.
  window.app.menuFor = (app = null) -> chooseMenu window.menus, accountKey(window.app), app
  window.app.resolveMenu = resolveMenu
  router = createShellRouter shellRoutes, {otherwise: landingRoute(), guards, label: 'parent', contextPrefix: 'elfeet/'}

  start_react = -> startReact router, {followsDevice: true}

  render_react_error = (error) -> renderReactError error

  # Whose token this session carries — asked of the server, never read off the
  # link (dead_session.coffee, cards 6aaeb53dc0a495ac26c96c2c and
  # 6ac8347717fd547aec27eb48). 'dead' is a 401: the token is refused.
  confirmSessionIdentity = () -> confirmTokenIdentity window.app?.loopbackAPI

  initialize = (route_to='dashboard', route_params={}) ->
    window.application_running = 'parent'
    # The boot read is not worth making with a token the server has already
    # refused (card 6ab16e9c013e5b1a5ad54628).
    return signOutToSignIn(start_react) if (await confirmSessionIdentity()) is 'dead'
    # THE BOOT READ IS NOT MADE ON A MANIFEST THAT DOES NOT SERVE IT — card
    # 6abade8186d61b9a8024b543, the teacher shell's guard (6ab69fbe) brought to
    # this shell, which never got it. Production CrashLog 33bf8dc0, /app#/dashboard,
    # 2026-09-28: a stored token the server accepted but mapped to no role, so
    # `/clientapi` answered 200 with the anonymous manifest and `refresh()` threw
    # `Account.getAccount is not a function` SYNCHRONOUSLY into the error
    # boundary — on every open from that device. A session this shell cannot
    # read is not a session: drop it and show sign-in.
    unless servesBootRead window.app?.loopbackAPI
      console.warn "This session's API does not serve Account.getAccount — signing out to the sign-in screen"
      return signOutToSignIn start_react
    # NOR WITH NO USER ID TO MAKE IT ABOUT — card 6ac8347717fd547aec27eb48,
    # production CrashLog 5c9a9e82 / 340b1790. A link that lost its uid on the
    # way installs a session with currentUserId '' (null after a reload), and
    # the boot read was getAccount({id: ''}): a 404, then a 400 on every
    # reload. confirmSessionIdentity has already asked the server whose token
    # it is; a session still unidentified after that is not one. Plain
    # sign-in, not the out-of-date QR message: the token may be perfectly
    # good, it is the link that was cut short.
    unless hasBootIdentity window.app?.loopbackAPI
      console.warn "This session carries no user id and the server could not say whose it is — signing out to the sign-in screen"
      return signOutToSignIn start_react
    # ONE RETRY ON AN ABORTED BOOT READ — card 6aab772ced72ee7fceb166f3. This
    # read runs before the router exists, so transition_recovery's onError hook
    # is not installed yet and cannot catch it; without this, a single transient
    # abort put a child on the "We have encountered an error" page with no way
    # out but a manual reload.
    retryAbortedRead((-> window.app.refresh()), (error) ->
      console.warn "App boot read was aborted (#{error?.message ? error}) — retrying once"
    ).then (response) ->
      if response.data?.login? # we did not fetch account data, send them to login screen...
        # login was successful, clear the QR login flag
        window.app.clearQRFlag()

        # Initialize i18n with user's preferred language
        # Check both snake_case (from cache) and camelCase (from DB) field names
        # For student sessions, use the student's preferred_language
        student0 = response.data.login.account.students?[0]
        preferredLang = response.data.login.preferredLanguage || response.data.login.preferred_language || student0?.preferred_language || 'en'
        # console.log "Initializing i18n with preferred language: #{preferredLang}"
        initI18n(clientAPI, preferredLang)

        # Initialize i18n registry
        window.i18nRegistry = new I18nRegistry(clientAPI)
        # Strip query parameters from route for cleaner tracking
        routeWithoutQuery = window.location.hash.split('?')[0]
        normalizedRoute = normalizeRoute(routeWithoutQuery)
        window.i18nRegistry.setContext('elfeet/init', normalizedRoute, 'elfeet')

        # Always fetch all translations from server for non-English locales
        # This ensures newly imported strings are loaded, even if localStorage cache exists
        # 'en-US' is not 'en': ask the framework whether this locale reads the
        # authored text before fetching the catalogue (card 6aa6c73847c945dd8596e7d9).
        if !window.i18nManager.readsSource()
          # console.log "⏳ Fetching all translations for #{preferredLang}..."
          await clientAPI.i18nString.find({where: {app: 'elfeet'}}).then (resp) ->
            cache = {}
            strings = if Array.isArray(resp) then resp else (resp?.data || [])
            for string in strings
              cache[string.hash] = string.text
            try
              # Save to localStorage
              localStorage.setItem("i18n_#{preferredLang}_elfeet", JSON.stringify(cache))
              # Merge with any existing cache (from upsertBatch responses)
              window.i18nTranslationCache ?= {}
              for hash, text of cache
                window.i18nTranslationCache[hash] = text
              # console.log "✅ Loaded #{Object.keys(cache).length} translations from server"
            catch e
              console.warn "Failed to cache:", e

        # THE ACCOUNT IS READ OFF THE APP, NOT OFF THE RESPONSE, and for one
        # night in September it was not there — card 6aae2221ed08d5788a4e1e14.
        # The stale-client reload branch returned from refresh() before
        # assigning it, `location.reload()` stopped nothing, and boot arrived
        # here and threw `undefined is not an object`. The error boundary put
        # the Application Error screen in front of a parent on iPhone Safari
        # at 11:45 PM.
        #
        # The cause is fixed where it belongs, in refresh() — the account is
        # assigned before any reload is scheduled. This falls back to the
        # response's own copy anyway, because the two are the same object and
        # a boot that has a login in hand should never be taken down by the
        # route it took to get here. It is the guard the title bars already
        # have, at the one place that decides which shell the family lands in.
        account = window.app.account ? response.data.login.account
        unless account?
          # Genuinely no account on a login that has one everywhere else: not
          # something to guess past. Say so where the crash reporter's console
          # tail will carry it, and let the boundary have it.
          console.error "SERIOUS ERROR: boot has a login with no account — cannot choose a shell"
          throw new Error 'boot: login carries no account'
        account_type = account.type
        # HOME IS ASKED FOR, NOT ASSUMED — card 6ac022cba664bc34d57be8c7. A boot
        # with nowhere particular to go, or a link to the dashboard, opens the
        # landing screen: the mobile App's dashboard on a mobile device that hosts
        # one, the dashboard everywhere else. A link's own query rides along.
        route_to ?= 'dashboard'
        [routeBase, routeQuery] = "#{route_to}".split('?')
        if routeBase is 'dashboard' and landingRoute() isnt 'dashboard'
          route_to = landingRoute() + (if routeQuery? then "?#{routeQuery}" else '')
        # THE DELETION PAGE IS ASKED FOR, NOT ROUTED TO — card
        # 6abdc5fa7009a562af26012d, for the reason the scholarship form below
        # is. Every branch here sends a family where its subscription says it
        # belongs, and deletion is never withheld (owner 2026-09-30): the iOS
        # app opens #/delete_account in Safari, and a lead mid-enrollment or a
        # lapsed family would otherwise sign in and land anywhere but the page
        # they came for. A family's only: a teacher, school or district goes to its portal as
        # usual, because staff delete those (card 6abe8f267009a562af26064f).
        askedForDeletion = route_to == DELETE_ACCOUNT_STATE and !window.app.isStudentLock() and selfDeletable(account)
        #not expired
        if !window.app.isStudentLock() and !askedForDeletion #if there is a student id it could be a student login
          if account_type == 'teacher' && !window.app.isMobile()
            token = window.app.loopbackAPI.accessTokenId
            userId = window.app.loopbackAPI.currentUserId
            return window.location = "/teacher?access_token=#{token}&uid=#{userId}"
          else if account_type in ['organization', 'district', 'school']
            token = window.app.loopbackAPI.accessTokenId
            userId = window.app.loopbackAPI.currentUserId
            role = window.app.loopbackAPI.currentUserRole
            if role == "Login.district"
              theurl = "/org?access_token=#{token}&uid=#{userId}&masquerade=district"
            else
              theurl = "/org?access_token=#{token}&uid=#{userId}"
            if window.app.isAndroid()
              return window.location = window.config.server+theurl
            else
              return window.location = theurl
            
        # The deletion page, decided above (askedForDeletion).
        if askedForDeletion
          window.location = routeHash route_to, route_params
          window.app.setInitialRouting(route_to)
          return start_react()

        # THE SCHOLARSHIP FORM IS ASKED FOR, NOT ROUTED TO — card
        # 6ab167dca4d698cda2b1faa2. Every branch below decides where a family
        # belongs from the shape of their subscription, and that is the wrong
        # question for this one screen: the family who needs a scholarship is
        # precisely the family whose subscription has lapsed, has no students
        # left, or never started. `update_scholarship` used to be honoured only
        # in the final `else`, so a Trial account or one with no students was
        # sent to #/application and a subscribed one with no students to the
        # Students screen — the link the customer wrote in about, going
        # anywhere but the form.
        #
        # Gated on the manifest rather than on the account, because that is the
        # thing that decides whether the screen can render at all
        # (subscriptionRouting.scholarshipIsServed).
        if route_to == SCHOLARSHIP_STATE and scholarshipIsServed(window.app)
          window.location = routeHash route_to, route_params
        else if route_to == ENROLL_COMPLETE_PATH.substring(1)
          # Back from a redirect-based payment method with the SetupIntent
          # confirmed and NOT YET subscribed — which is exactly the account
          # shape every branch below sends to #/application, restarting the
          # form. The landing state does the subscribe; let it
          # (card 6a9cb1d0ea6ab4f8aea9c463). Assigning a hash keeps the
          # query string Stripe appended.
          #
          # Deliberately NOT routeHash: this branch is the Stripe return, whose
          # parameters are in the URL's own query string, not a deep link's
          # redirectParams (card 6aab72ceed72ee7fceb166c3).
          window.location = "#/#{route_to}"
        else if isActiveSubscription(response.data.login.account) && window.app.students.length > 0
          # if the user still needs to complete the onboarding process, send them there
          if account.force_onboarding && route_to != 'application'
            window.location = "#/assignment"
          else
            window.location = routeHash route_to, route_params
        else if window.app.isUnsubscribedTeacher()
          # A TEACHER'S TRIAL THAT HAS RUN OUT — card 6ac3ec94b9e010761617d2cf.
          # isUnsubscribedTeacher is true for every Trial teacher, live or
          # lapsed, and that is right for the teacher themself: Login.role
          # gives a teacher account Login.teacher whatever its dates, and that
          # manifest renders the dashboard. A STUDENT-LOCKED session on the
          # same account is minted by Student.role instead, which reads the
          # end date alone — so once the trial ends the child holds
          # Student.unsubscribed, which has no History and no
          # Student.playtime_stats. Sending that session to the dashboard was
          # production CrashLog 3ff3c45f. It goes where the student-lock arm
          # below sends every child with nothing to play: a screen that reads
          # nothing. A live trial still plays.
          if window.app.isStudentLock() and !studentSessionSubscribed(account)
            window.location = '#/subscription_expired'
          else
            window.location.hash = routeHash route_to, route_params
        else if subscribedWithoutStudents(response.data.login.account, window.app.students, window.app.sharedStudents)
          # A paying account with every student removed. The checkout below is
          # for accounts with nothing to pay with; this one has a live
          # subscription and nobody to teach, and its role (Login.subscribed)
          # holds no Account.subscribe grant, so the form would end in a raw
          # 401. Owner decision 2026-09-06, card 6a9cc47fdbd420ed5794d248: the
          # Students screen, not #/application.
          route_to = 'account'
          window.location = STUDENTS_SCREEN_HASH
        else if (window.app.students.length == 0 && window.app.sharedStudents.length == 0) || response.data.login.account.status is 'Trial'
          # route_to is REPLACED here, so the link's own params do not travel
          # with it — they described the screen being diverted away from
          # (card 6aab72ceed72ee7fceb166c3).
          route_to = 'application'
          window.location = "#/#{route_to}"
        else
          # NOT AN ACTIVE SUBSCRIPTION — and that is one question, asked once.
          # Card 6ab015e51c823bb5a74a1ec5.
          #
          # This arm used to be `else if moment(account.subscription_end)
          # .isBefore(moment())`, a DATE-ONLY test, with a bare `else` behind
          # it that fell through to the dashboard. The server does not decide
          # who is subscribed that way: Login.role (common/models/Login.coffee)
          # requires status == 'Subscribed' AND the end date in the future, and
          # it is Login.role that mints the principal whose ACLs BUILD THIS
          # SESSION'S CLIENT API.
          #
          # So an account with the end date in the future and any status other
          # than exactly 'Subscribed' — a pilot, a hand-made row, a pair of
          # fields that drifted — passed this date-only gate, was sent to the
          # dashboard, and was then served the UNSUBSCRIBED manifest: no
          # History model and no Student.active_history, which is the pair of
          # TypeErrors on /app#/dashboard the card was filed for. The family
          # was not browsing where it should not be; it was SENT there.
          #
          # Every account with an active subscription and a student to teach
          # took the first branch above, so everything arriving here is a
          # family with something to buy. Send them to the screen that says
          # so. There is no dashboard fall-through any more: a screen is
          # reached by being able to render it, not by no other branch
          # matching. Same reading as card 6aa6cd1fcbca3e2eac7b42ef (the
          # student-lock arm below) and card 6aaea3e58887cd49ef88bfc3 (the
          # #/login router state).
          # `update_scholarship` was handled at the top of this chain since
          # card 6ab167dca4d698cda2b1faa2 — for every account shape, not only
          # this one. What is left here is the student-locked session, which
          # the manifest gate up there refuses and which belongs on a screen
          # that reads nothing.
          if window.app.isStudentLock()
            # A student session carries no billing fields to route on and has
            # no business on the parent's screens (card 6aa4d3ed1c031a8daf2e49c3).
            # Not the dashboard either: Student.unsubscribed's manifest has no
            # History or PosetProfile, so it crashed to the error screen (card
            # 6aa6cd1fcbca3e2eac7b42ef). A screen that reads nothing.
            window.location = '#/subscription_expired'
          else if response?.data?.login?.account?.customer?.id? || response?.data?.login?.account?.organization? || response?.data?.login?.account?.transaction?
            window.location = "#/account"
          else
            window.location = '#/application'

        # WEBFLOW :: save the initial routing to a variable for webflow
        window.app.setInitialRouting(route_to)

        start_react()
      else
        window.location.hash = ''
    .catch (error) ->
      # AN EXPIRED SESSION IS NOT A CRASH — card 6ab16e9c013e5b1a5ad54628.
      #
      # getAccount's 401 used to arrive here and go straight to
      # render_react_error, which throws into the ErrorBoundary: a parent
      # whose saved session had expired opened /app and read "We have
      # encountered an error". confirmSessionIdentity catches this one step
      # earlier for any principal that has whoami on its manifest; a child's
      # Student session does not, so the same answer has to be understood
      # here too.
      #
      # Everything else still gets the apology screen it had — a 500, a
      # throw inside refresh, a connection that is genuinely gone after
      # retryAbortedRead has spent its three tries.
      if isDeadSession error
        console.warn "The stored session token is no longer valid (401) — showing the sign-in screen"
        return signOutToSignIn(start_react)
      render_react_error(error)

  window.initialize = initialize
  if params.code? && window.app.loopbackAPI?
      console.log "Send Code to server to check login"
      window.app.loopbackAPI.clearUser()
      # A CODE IS SPENT THE MOMENT IT IS SENT — card 6ab16a49a4d698cda2b1fab0.
      #
      # This line used to sit inside the `.then`, on the success path only. So
      # a failed exchange left `?code=` in the address bar, and every ordinary
      # thing a person does with a page that did not work — reload it, reopen
      # the tab, restore the session tomorrow — posted the SAME code again. An
      # OAuth authorization code is single-use: Clever refuses the second one
      # at once, which is exactly the shape production showed on 2026-09-21
      # (six of seven failures refused in 98-145ms), and each refusal logged a
      # SERIOUS ERROR that we had generated ourselves.
      #
      # Cleared BEFORE the post, not after it: between the request and its
      # answer is the window a reload actually happens in. What is lost by
      # clearing early is nothing — the code is in `params` already, and it
      # can never be used a second time by anyone.
      window.history.replaceState {}, document.title, "/app"
      window.app.loopbackAPI.Login.cleverCode({code: params.code}).then (response) ->
        console.log "Got response from server:"
        console.dir response
        if response.data?.success == false
          window.app.login_error_message = response.data?.message
          # A FAILED CLEVER SIGN-IN OFFERS A FRESH ONE — card
          # 6ab16a49a4d698cda2b1fab0. The code in the URL is gone (it was
          # spent), so "try again" cannot mean reloading this page; it has to
          # mean a new trip to Clever's authorize endpoint. The sign-in screen
          # reads this flag and says so.
          window.app.clever_sign_in_failed = true
          return start_react()
        else if response.data?.data?
          token_info = response.data.data
          window.app.loopbackAPI.setUser(token_info.access_token, token_info.user_id, undefined, token_info.student_id)
          window.app.loopbackAPI.resetAuthHeader()
          # THE SCHEMA MUST BE RELOADED FOR THE PRINCIPAL WE HAVE JUST BECOME —
          # card 6aad874f6e6a1e18a0903547.
          #
          # loadSchema() at the top of this file ran BEFORE the Clever exchange,
          # with no token, so the manifest in hand carries only the unauthorized
          # surface: Account exposes getPlans and nothing else (Account.json
          # acls.unauthorized). initialize() -> Application.refresh() then calls
          # Account.getAccount, which is not on that manifest, and every Clever
          # student — a school Chromebook, every time — landed on 'We have
          # encountered an error' with a perfectly good session in storage.
          # Three crashes in three minutes on production, fingerprint e60ddb4.
          #
          # The comment at the head of this file pre-sets auth for the
          # ?access_token= path precisely so its loadSchema runs authenticated;
          # the ?code= path cannot do that, because the token does not exist
          # until the server answers. So it reloads afterwards instead —
          # checkout.coffee and enroll_complete.coffee already do this after
          # their own logins.
          #
          # Never fatal: a failed reload leaves the pre-login manifest, which is
          # the state this branch shipped in. start_react() shows the sign-in
          # screen rather than the error boundary.
          try
            await window.app.loopbackAPI.loadSchema()
          catch err
            console.warn "Could not reload the schema after a Clever sign-in: #{err?.message or err}"
            window.app.login_error_message = window.app.login_error_message or 'Could not finish signing in. Please try again.'
            window.app.clever_sign_in_failed = true
            return start_react()
        # The URL was cleared before the exchange was posted (above), so there
        # is nothing left to strip here.
        initialize()
      .catch (error) ->
        # A REJECTED EXCHANGE MUST LAND ON THE SIGN-IN SCREEN — card
        # 6aadb69fd60dadb9b2befafe.
        #
        # This `.then` had no `.catch`. `Login.cleverCode` rejects on anything
        # that is not a well-formed answer — a 5xx from Clever, a timeout, a
        # dropped connection — and with nothing to catch it, the promise
        # rejected, `initialize()` was never reached, and the bootstrap simply
        # stopped. The page sat on "Loading App..." for ever: no message, no
        # retry, nothing to tell a child or a teacher whether to wait. On a
        # school Chromebook arriving from a Clever tile that is the whole class,
        # and support gets "the app doesn't load" with nothing to go on.
        #
        # THE HANDLED FAILURE WAS ALWAYS FINE and this deliberately joins it
        # rather than inventing a second path: the `success == false` branch
        # above sets `login_error_message` and calls `start_react()`, which is
        # the sign-in screen with the reason on it. A rejection is the same
        # event — we did not get a session — so it gets the same landing.
        #
        # The served message is preferred when there is one; a rejection often
        # carries nothing a family could read, so there is a plain fallback.
        console.warn "Clever sign-in failed: #{error?.message or error}"
        served = error?.response?.data?.message or error?.response?.data
        window.app.login_error_message =
          if typeof served == 'string' and served.length and served.length < 200
            served
          else
            'We could not finish signing you in with Clever. Please try again.'
        window.app.clever_sign_in_failed = true
        start_react()
  else if window.app.loopbackAPI.isLoggedIn()
    # reset login if the link is for somebody else: a new user (fast_create),
    # a different student, or a different login (card 6ac449205e862d397de34685)
    if linkReplacesSession(params, window.app.loopbackAPI)
      window.app.loopbackAPI.setUser(params.access_token, params.uid, undefined, params.studentId)
      window.app.loopbackAPI.resetAuthHeader()
      window.history.replaceState {}, document.title, "/app"
      # The enroll / switch-student variant of the same branch, and the same
      # ruling (card 6aae789375583968aa813992). This one is worse than the
      # branch below, because it REPLACED a working session with a dead token:
      # the family was signed in until they opened the old link.
      if window.app.loopbackAPI.isLoggedIn()
        initialize params.redirectTo, decodeRedirectParams(params.redirectParams)
      else
        console.warn "The access_token in this link could not authenticate — showing the out-of-date QR code message"
        window.app.setStaleLinkFlag()
        start_react()
    else if params.access_token? && params.redirectTo?
      # A SERVER-MINTED DEEP LINK ON AN ALREADY-INSTALLED SESSION — card
      # 6aab72ceed72ee7fceb166c3, found by driving the real link on the seat.
      #
      # The `access_token?` branch further down is where redirectTo used to be
      # read, and it is UNREACHABLE for a link that carries a token: the
      # module-scope pre-set above (`if params.access_token? …
      # clientAPI.setUser`) installs the session before this runs, so
      # isLoggedIn() is already true and control never gets there. Without this
      # branch the link fell to the empty-hash case below and opened the
      # dashboard — the redirect discarded in silence, which is exactly the
      # symptom the card describes.
      #
      # Still gated on access_token, per the owner's ruling 2026-09-17: a
      # redirect is honoured only where the server minted the link.
      window.history.replaceState {}, document.title, "/app"
      initialize params.redirectTo, decodeRedirectParams(params.redirectParams)
    else if !window.location.hash? || window.location.hash is '' || window.location.hash is '#/'
      initialize()
    else if window.location.hash is '#/logout'
      window.app.loopbackAPI.logout()
      # Render, or a page loaded at #/logout signs out onto a blank page; the
      # router's logout state lands on the login screen.
      start_react()
    else
      route = window.location.hash.substring 2
      initialize route
  else if params.access_token? && !/#/.test(params.studentId)
    window.app.loopbackAPI.setUser(params.access_token, params.uid, undefined, params.studentId)
    window.app.loopbackAPI.resetAuthHeader()
    window.history.replaceState {}, document.title, "/app"
    # A TOKEN THAT CANNOT AUTHENTICATE MUST NOT BOOT AS SIGNED IN — card
    # 6aae789375583968aa813992, owner ruling 2026-09-19.
    #
    # setUser clears the session rather than installing one when the token
    # fails the <Model>Auth_ framing, so isLoggedIn() is false and the manifest
    # in hand is the ANONYMOUS one: Account carries getPlans and nothing else.
    # initialize() -> Application.refresh() then called Account.getAccount,
    # which is not on it, and the family got the error boundary instead of a
    # way back in. Same shape as the Clever branch's fallback above: when we
    # did not get a session, land on the sign-in screen.
    #
    # The ruling is that this is THE OLD QR CODE case and should say so, so
    # login.coffee shows a plain message off the flag and dismissing it leaves
    # the family on the sign-in screen.
    if window.app.loopbackAPI.isLoggedIn()
      initialize params.redirectTo, decodeRedirectParams(params.redirectParams)
    else
      console.warn "The access_token in this link could not authenticate — showing the out-of-date QR code message"
      window.app.setStaleLinkFlag()
      start_react()
  else
    start_react()

